import {
  Box,
  Button,
  Flex,
  Text,
  Image,
  Spinner,
  Center,
  Icon,
} from '@chakra-ui/react'
import {Modal, Steps} from 'antd'
import {
  EXAM_BODY_TYPE,
  ExamPartType,
  STEP_TITLE_TYPE,
} from '@pages/ExamPage/examPageModel'
import StepsItem from '@assets/svgs/checked_step.svg'
import {CommonColors} from '@utils/CommonStyles'
import BackgroundExamRoom from '@assets/images/exam/background-exam-room.png'
import SendIcon from '@assets/svgs/exam/send.svg'
import ComeBackIcon from '@assets/svgs/exam/come-back.svg'
import sendWhiteIcon from '@assets/svgs/exam/send-white.svg'
import {useState} from 'react'
import useExamRoom from './useExamRoom'
import DescribeItem from './DescribeItem'
import QuestionListItem from './QuestionListItem'
import QuestionItem from './QuestionItem'
import FinishQuestion from './FinishQuestion'
import CountdownTimer from './shared/CountdownTimer'
import ExamMic from './shared/ExamMic'
import {useLocation, useNavigate} from 'react-router-dom'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {ReactComponent as ExclamationCircle} from '@assets/svgs/exclamation-circle.svg'
import {useDispatch, useSelector} from 'react-redux'
import {
  updateIsShowModalExitFlow,
  updateIsShowReportErrorForm,
} from '@redux/shared/shared'
import CloseIcon from '@assets/svgs/close.svg'
import FormReportError from '@components/FormReportError'
import ModalVerifyClose from '@pages/ConverstationPage/components/ModalVerifyClose'
import {updateIsShowConfirmClose} from '@redux/gym/gymSlice'
import {getFeedbackExitFlowType} from '@utils'

export default function ExamRoom() {
  const {
    data,
    testPart,
    questionList,
    currentStep,
    showBodyType,
    isShowBtnContinue,
    isShowAnswer,
    isLoading,
    isLoadingSendAudio,
    showQuestion,
    answerData,
    countdownTimerRef,
    countdownTimerPart2Ref,
    examMicRef,
    audioRef,
    numberRecordingError,
    isRecordingError,
    handleStart,
    handleSaveAudio,
    handleContinue,
    handleTimeEnded,
    handleTimePrepare,
    handleSendAnswer,
    handleSendComBackRecord,
  } = useExamRoom()
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const [isShowCountDown, setIsShowCountDown] = useState<any>(false)
  const navigate = useNavigate()
  const location = useLocation()
  const {entry_point, feature_name} = location.state || {}
  const dispatch = useDispatch()
  const handleCancelModal = () => {
    navigate(-1)
  }

  const handleClickClose = () => {
    if (
      entry_point === 'ROADMAP' &&
      !dataFeedbackOverview?.feedback_data[
        getFeedbackExitFlowType(location.pathname)
      ]?.is_completed
    ) {
      dispatch(updateIsShowModalExitFlow(true))
    } else {
      dispatch(updateIsShowConfirmClose(true))
    }
  }

  const renderHeader = () => {
    const stepParts = data?.test_parts?.map((e: any, i: number) => {
      return {
        title: STEP_TITLE_TYPE[e.type as keyof typeof STEP_TITLE_TYPE],
        icon: currentStep >= i + 1 && <Image src={StepsItem} />,
      }
    })
    return (
      <Flex
        justifyContent={'center'}
        alignItems={'center'}
        gap={'24px'}
        maxW={'1200px'}
        w={'100%'}
        mt={{base: '20px', md: '40px'}}
        mx={'auto'}
        px={{base: '16px', md: '0px'}}>
        <Image src={CloseIcon} onClick={handleClickClose} cursor={'pointer'} />
        <Steps
          style={{
            width: '80%',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 400,
          }}
          current={currentStep}
          items={stepParts}
        />
        <Icon
          w={'24px'}
          h="24px"
          viewBox="0 0 24 24"
          cursor={'pointer'}
          sx={{
            path: {
              fill: '#000000',
            },
          }}
          onClick={() => {
            dispatch(updateIsShowReportErrorForm(true))
          }}>
          <ExclamationCircle />
        </Icon>
      </Flex>
    )
  }

  const renderBody = () => {
    if (isLoading) {
      return (
        <Flex
          align={'center'}
          w={'100%'}
          h={'100vh'}
          justifyContent={'center'}
          flexDirection={'column'}>
          <Spinner size="xl" />
          <Text fontWeight={'600'} fontSize={24}>
            ...Loading
          </Text>
        </Flex>
      )
    }
    switch (showBodyType) {
      case EXAM_BODY_TYPE.DESCRIBE:
        return <DescribeItem data={testPart} handleStart={handleStart} />
      case EXAM_BODY_TYPE.QUESTION_LIST:
        return (
          <QuestionListItem data={questionList} handleStart={handleStart} />
        )
      case EXAM_BODY_TYPE.QUESTION:
        return (
          <QuestionItem
            data={testPart}
            questionList={questionList}
            showQuestion={showQuestion}
            isShowAnswer={isShowAnswer}
            isShowBtnContinue={isShowBtnContinue}
            handleTimePrepare={handleTimePrepare}
            audioRef={audioRef}
            countdownTimerPart2Ref={countdownTimerPart2Ref}
          />
        )
      case EXAM_BODY_TYPE.FINISH_QUESTION:
        return <FinishQuestion />
      default:
        return null
    }
  }

  return (
    <Flex
      gap="middle"
      height={'100vh'}
      position={'relative'}
      overflow={'hidden'}>
      <Image
        src={BackgroundExamRoom}
        position={'absolute'}
        w={'100%'}
        h={'100%'}
      />
      <Flex flexDirection={'column'} w={'100%'} h={'100vh'} zIndex={'1'}>
        {renderHeader()}
        {renderBody()}
        {showBodyType === EXAM_BODY_TYPE.QUESTION && (
          <Flex
            w={'100%'}
            flexDirection={'column'}
            alignItems={'center'}
            mt={'30px'}
            position={'absolute'}
            bottom={'30px'}>
            {!isShowBtnContinue && !isShowAnswer && (
              <Box minW={'250px'}>
                {!isShowCountDown && (
                  <Text
                    mb={'16px'}
                    color={'#1F1F1F'}
                    fontSize={'16px'}
                    textAlign={'center'}>
                    {isLoadingSendAudio
                      ? 'Đang xử lý dữ liệu...'
                      : `Bạn có ${questionList[showQuestion]?.duration ?? 0}s để nói
                    phần thi này`}
                  </Text>
                )}

                <Box
                  h={!isShowCountDown ? '0px' : 'unset'}
                  overflow={!isShowCountDown ? 'hidden' : 'visible'}>
                  <CountdownTimer
                    ref={countdownTimerRef}
                    initialTime={questionList[showQuestion]?.duration}
                    onTimeEnded={handleTimeEnded}
                  />
                </Box>
                <ExamMic
                  ref={examMicRef}
                  countdownTimerRef={countdownTimerRef}
                  onRecordingComplete={handleSaveAudio}
                  setIsShowCountDown={setIsShowCountDown}
                />
              </Box>
            )}
            {isShowBtnContinue && (
              <Button
                isDisabled={isLoadingSendAudio}
                w={140}
                h={70}
                mt={'80px'}
                onClick={handleContinue}
                borderRadius={50}
                _hover={{
                  bgGradient: 'linear(to-t, #07D2FF, #00A3FF)',
                }}
                color={CommonColors.white}
                bgGradient="linear(to-b, #07D2FF, #00A3FF)">
                {currentStep + 1 < data?.test_parts?.length
                  ? 'Tiếp tục'
                  : isLoadingSendAudio
                    ? 'Vui lòng đợi'
                    : entry_point === 'ROADMAP'
                      ? 'Hoàn thành'
                      : 'Xem kết quả'}
              </Button>
            )}
            {isShowAnswer && (
              <Flex px={{base: '16px', md: '0px'}}>
                <Flex gap={{base: '12px', md: '16px'}} mx={'auto'} alignItems={'center'}>
                  <Center
                    flexShrink={0}
                    cursor={'pointer'}
                    w={{base: '48px', md: '64px'}}
                    h={{base: '48px', md: '64px'}}
                    borderRadius={'50%'}
                    boxShadow={'0px 8px 20px 0px rgba(0, 0, 0, 0.10)'}
                    bg={'white'}
                    onClick={handleSendComBackRecord}>
                    <Image src={ComeBackIcon} w={{base: '20px', md: '24px'}} />
                  </Center>
                  <Box
                    bg={'#072941'}
                    w={{base: 'calc(100vw - 120px)', md: '560px'}}
                    maxW={'560px'}
                    flexShrink={0}
                    borderRadius={{base: '16px', md: '24px'}}>
                    <Flex
                      p={{base: '16px', md: '24px'}}
                      gap={{base: '12px', md: '16px'}}
                      alignItems={'center'}
                      justifyContent={'space-between'}>
                      <Text
                        className="scroll-bar"
                        fontSize={{base: '16px', md: '24px'}}
                        color={'white'}
                        maxH={{base: '80px', md: '120px'}}
                        overflow={'auto'}>
                        {isRecordingError
                          ? 'Thu âm bị lỗi, hãy thử lại'
                          : answerData?.text}
                      </Text>
                      {!isRecordingError && (
                        <Image
                          cursor={'pointer'}
                          src={sendWhiteIcon}
                          onClick={handleSendAnswer}
                          w={{base: '20px', md: '24px'}}
                        />
                      )}
                    </Flex>
                  </Box>
                </Flex>
              </Flex>
            )}
          </Flex>
        )}
      </Flex>
      {isShowAnswer && testPart?.type === ExamPartType.PART_TWO && (
        <Flex
          className="modal"
          position={'absolute'}
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg={'rgba(0,0,0,0.8)'}
          zIndex={10}>
          <Flex
            bg={'#F0F6FD'}
            h={{base: 'calc(100% - 40px)', md: 'calc(100% - 80px)'}}
            mt={'auto'}
            w={'100%'}
            borderRadius={{base: '20px 20px 0px 0px', md: '30px 30px 0px 0px'}}
            p={{base: '30px 16px 20px 16px', md: '60px 40px 40px 40px'}}>
            <Flex
              maxW={'900px'}
              w={'100%'}
              mx={'auto'}
              flexDirection={'column'}
              gap={{base: '20px', md: '40px'}}>
              <Flex justifyContent={'space-between'} alignItems={'center'}>
                <Text fontSize={{base: '24px', md: '40px'}} fontWeight={700}>
                  Bài nói của bạn
                </Text>
                <Flex gap={{base: '12px', md: '20px'}}>
                  <Center
                    cursor={'pointer'}
                    w={{base: '48px', md: '64px'}}
                    h={{base: '48px', md: '64px'}}
                    borderRadius={'50%'}
                    boxShadow={'0px 8px 20px 0px rgba(0, 0, 0, 0.10)'}
                    onClick={handleSendComBackRecord}>
                    <Image src={ComeBackIcon} w={{base: '20px', md: '24px'}} />
                  </Center>
                  <Center
                    cursor={'pointer'}
                    w={{base: '48px', md: '64px'}}
                    h={{base: '48px', md: '64px'}}
                    borderRadius={'50%'}
                    boxShadow={'0px 8px 20px 0px rgba(0, 0, 0, 0.10)'}
                    onClick={handleSendAnswer}>
                    <Image src={SendIcon} w={{base: '20px', md: '24px'}} />
                  </Center>
                </Flex>
              </Flex>
              <Flex
                className="scroll-bar"
                overflow={'auto'}
                flex={1}
                borderRadius={{base: '16px', md: '24px'}}
                border={'1px solid #D9D9D9'}
                bg={'#FFFFFF'}>
                <Box p={{base: '20px', md: '30px'}}>
                  <Text fontSize={{base: '16px', md: '24px'}}>{answerData?.text}</Text>
                </Box>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      )}
      <Modal
        title={
          <Text textAlign={'center'} fontSize={'24px'} fontWeight={600}>
            OOPS!
          </Text>
        }
        footer={null}
        centered={true}
        closeIcon={null}
        open={numberRecordingError === 3}
        onCancel={handleCancelModal}>
        <Text textAlign={'center'} fontSize={'18px'}>
          Có vẻ Mic của bạn đang gặp sự cố, hãy kiểm tra và thử lại sau nhé!
        </Text>
        <Center>
          <GlobalButton mt={'16px'} onClick={handleCancelModal}>
            Xác nhận
          </GlobalButton>
        </Center>
      </Modal>
      {feature_name && (
        <FormReportError feature={feature_name} screen={feature_name} />
      )}
      <ModalVerifyClose />
    </Flex>
  )
}
